module.exports = __webpack_public_path__ + "img/icon_sec6_03.b409379b.png";